import * as RSelect from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';
import './Select.css';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export interface SelectProps {
  value?: string;
  onValueChange?: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  'aria-label'?: string;
  className?: string;
}

// Accessible, theme-styled replacement for native <select className="form-input">.
// Radix gives keyboard nav + a dark-themeable popup the native control can't.
export function Select({
  value,
  onValueChange,
  options,
  placeholder = 'Select…',
  disabled,
  id,
  className,
  'aria-label': ariaLabel,
}: SelectProps): JSX.Element {
  return (
    <RSelect.Root value={value} onValueChange={onValueChange} disabled={disabled}>
      <RSelect.Trigger
        id={id}
        className={['dsr-select-trigger', className].filter(Boolean).join(' ')}
        aria-label={ariaLabel}
      >
        <RSelect.Value placeholder={placeholder} />
        <RSelect.Icon className="dsr-select-icon">
          <ChevronDown size={15} />
        </RSelect.Icon>
      </RSelect.Trigger>
      <RSelect.Portal>
        <RSelect.Content className="dsr-select-content" position="popper" sideOffset={4}>
          <RSelect.Viewport className="dsr-select-viewport">
            {options.map((o) => (
              <RSelect.Item
                key={o.value}
                value={o.value}
                disabled={o.disabled}
                className="dsr-select-item"
              >
                <RSelect.ItemText>{o.label}</RSelect.ItemText>
                <RSelect.ItemIndicator className="dsr-select-indicator">
                  <Check size={14} />
                </RSelect.ItemIndicator>
              </RSelect.Item>
            ))}
          </RSelect.Viewport>
        </RSelect.Content>
      </RSelect.Portal>
    </RSelect.Root>
  );
}
